export const regions = {
  global: {
    code: 'global',
    name: 'Global',
    flag: '🌍',
    language: 'en',
    timezone: 'UTC',
    enabled: true,
    path: '',
    fullUrl: 'https://ishopgenie.co'
  },
  my: {
    code: 'my',
    name: 'Malaysia',
    flag: '🇲🇾',
    language: 'en',
    timezone: 'Asia/Kuala_Lumpur',
    enabled: false, // Disabled for now, ready for future
    path: '/my',
    fullUrl: 'https://ishopgenie.co/my'
  },
  sg: {
    code: 'sg',
    name: 'Singapore',
    flag: '🇸🇬',
    language: 'en',
    timezone: 'Asia/Singapore',
    enabled: false,
    path: '/sg',
    fullUrl: 'https://ishopgenie.co/sg'
  },
  ph: {
    code: 'ph',
    name: 'Philippines',
    flag: '🇵🇭',
    language: 'en',
    timezone: 'Asia/Manila',
    enabled: false,
    path: '/ph',
    fullUrl: 'https://ishopgenie.co/ph'
  },
  id: {
    code: 'id',
    name: 'Indonesia',
    flag: '🇮🇩',
    language: 'id',
    timezone: 'Asia/Jakarta',
    enabled: false,
    path: '/id',
    fullUrl: 'https://ishopgenie.co/id'
  }
};

export const getRegionByCode = (code) => {
  return regions[code] || regions.global;
};

export const getEnabledRegions = () => {
  return Object.values(regions).filter(region => region.enabled);
};

export const getAllRegions = () => {
  return Object.values(regions);
};

export const isValidRegion = (code) => {
  return code in regions && regions[code].enabled;
};

export const getRegionFromPath = (pathname) => {
  const match = pathname.match(/^\/(my|sg|ph|id)/);
  if (match) {
    const regionCode = match[1];
    // Only return region if it's enabled
    return regions[regionCode]?.enabled ? regionCode : 'global';
  }
  return 'global';
};
